module.exports = __webpack_public_path__ + "static/GPE_blue-212a28f638e72d2191fe392d86c06cc6.png";